import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { label: "Tech", href: "features" },
  { label: "About", href: "about" },
  { label: "Updates", href: "updates" },
  { label: "Contact", href: "contact" },
];

const NavBar = ({ activeSection }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.getElementById(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <button
            type="button"
            className="flex items-center gap-3 group bg-transparent border-none cursor-pointer p-0"
            onClick={scrollToTop}
          >
            <img 
              src="/images/logo.png" 
              alt="All Animal App Logo" 
              className="w-10 h-10 rounded-full object-cover"
            />
            <span className="font-bold text-lg tracking-tight text-[#3a3a3a]">
              All Animal App<sup className="text-xs font-semibold">™</sup>
            </span>
          </button>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={`#${item.href}`}
                onClick={(e) => handleClick(e, item.href)}
                className={`px-4 py-2 text-sm font-medium tracking-wide transition-colors duration-300 rounded-lg ${
                  activeSection === item.href
                    ? "text-[#6B8F8A] bg-[#6B8F8A]/10"
                    : "text-[#6b7280] hover:text-[#6B8F8A] hover:bg-[#6B8F8A]/5"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center">
            <a
              href="#signup"
              onClick={(e) => handleClick(e, "signup")}
              className="text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-300 bg-[#6B8F8A] text-white hover:bg-[#5a7f7a]"
            >
              Join Mailing List
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 text-[#6b7280]"
            aria-label={mobileOpen ? "Close menu" : "Open menu"}
          >
            {mobileOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={`#${item.href}`}
                onClick={(e) => handleClick(e, item.href)}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  activeSection === item.href
                    ? "text-[#6B8F8A] bg-[#6B8F8A]/10"
                    : "text-[#6b7280] hover:text-[#6B8F8A] hover:bg-[#6B8F8A]/5"
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#signup"
              onClick={(e) => handleClick(e, "signup")}
              className="bg-[#6B8F8A] hover:bg-[#5a7f7a] text-white text-sm font-semibold px-4 py-3 rounded-full transition-colors duration-200 text-center mt-2"
            >
              Join Mailing List
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavBar;
